import { useEffect, useReducer } from "react";
import { reportError } from "utils/frontend_error_reporting";
import OrchidDriveDownloadProgressReducer from "../reducers/orchidDriveDownloadProgress";

export function useDownloadProgress() {
  const [downloadProgress, downloadProgressDispatch] = useReducer(
    OrchidDriveDownloadProgressReducer,
    [],
  );

  useEffect(() => {
    function handleMessage(event: MessageEvent) {
      console.log("WHITEMEOW", event.data);
      try {
        switch (event.data.type) {
          case "orchid_drive_download_status": {
            downloadProgressDispatch({
              type: "status",
              timeStamp: new Date(),
              oldTimeStampThreshold: new Date().getTime() - 60 * 60 * 1000,
              downloadSource: event.data.downloadSource,
              status: event.data.status,
              totalChunkCount: event.data.totalChunkCount,
              files: event.data.files,
            });
            break;
          }
          case "orchid_drive_download_failed": {
            downloadProgressDispatch({
              type: "failed",
              timeStamp: new Date(),
              downloadSource: event.data.downloadSource,
              error: event.data.error,
            });
            break;
          }
          case "orchid_drive_download_progress": {
            if (
              ["view", "download"].includes(
                event.data.downloadSource.operation,
              ) &&
              event.data.fileDataId !== event.data.downloadSource.fileDataId
            ) {
              throw new Error("invalid download progress");
            }
            downloadProgressDispatch({
              type: "progress",
              timeStamp: new Date(),
              downloadSource: event.data.downloadSource,
              fileDataId: event.data.fileDataId,
              chunksDownloaded: event.data.chunksDownloaded,
            });
            break;
          }
        }
      } catch (err: any) {
        reportError({
          reporter_module: "useDownloadProgress",
          context: { func: "handleMessage" },
          err,
        });
      }
    }

    navigator.serviceWorker?.addEventListener("message", handleMessage, false);
    return () =>
      navigator.serviceWorker?.removeEventListener("message", handleMessage);
  }, []);

  return downloadProgress;
}
